import { render, staticRenderFns } from "./TextArea-Changable.vue?vue&type=template&id=70bea299&scoped=true&"
import script from "./TextArea-Changable.vue?vue&type=script&lang=js&"
export * from "./TextArea-Changable.vue?vue&type=script&lang=js&"
import style0 from "./TextArea-Changable.vue?vue&type=style&index=0&id=70bea299&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bea299",
  null
  
)

export default component.exports